"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildWsRpcClient = void 0;
const constants_iso_1 = require("@wranggle/constants-iso");
const shared_utils_iso_1 = require("@wranggle/shared-utils-iso");
const rpc_core_1 = require("@wranggle/rpc-core");
const rpc_ws_transport_for_client_1 = require("./internal/rpc-ws-transport-for-client");
const extract_and_parse_message_1 = require("./internal/extract-and-parse-message");
const HousekeepingMessageMarker = '_$w_wsAux'; // todo: to shared location with ws-server
const DefaultTimeoutMs = 2000;
/**
 * Sets up a WebSocket connection and negotiates the creation of an rpc channel shared by the WsRpcServer.
 *
 * Warning: not ready for use with WsReconnectingClient. Need to think through how existing rpc endpoints should handle the
 *  case of a disconnect. Buffer pending messages? Update transport on existing endpoints? Require recreation from scratch wherever used?
 *
 * @param args
 */
function buildWsRpcClient(args) {
    return __awaiter(this, void 0, void 0, function* () {
        let { transport, requestRpcChannel, timeoutMs } = args;
        transport = _isRpcWsTransportForClient(transport) ?
            transport :
            new rpc_ws_transport_for_client_1.RpcWsTransportForClient(transport);
        const connResult = yield transport.promisedConnection();
        if (connResult !== true) {
            throw new shared_utils_iso_1.PlusPlusPlus(connResult);
        }
        const dataForRpcChannel = (typeof requestRpcChannel === 'function' ? yield requestRpcChannel() : requestRpcChannel) || {};
        dataForRpcChannel[constants_iso_1.Internal_WsRpcHandshakeTokenAttribName] = shared_utils_iso_1.createUid();
        const respData = yield _requestServersideEndpointForChannel({
            transport,
            dataForRpcChannel,
            timeoutMs: timeoutMs || DefaultTimeoutMs,
        });
        if (!respData || !respData.rpcChannel) {
            throw new Error(`WsRpcServer denied establishing an endpoint: ${JSON.stringify(respData)}`); // todo: PlusPlusPlus
        }
        const rpcEndpoint = new rpc_core_1.WranggleRpc({
            transport,
            channel: respData.rpcChannel,
            // globalRequestOpts: {}
            // debug: (data: DebugHandlerActivityData) => {},
        });
        transport.addDisconnectHandler((err) => {
            rpcEndpoint && rpcEndpoint.abortEndpoint(err || {
                errorCode: 'RpcTransportFailed',
            });
        });
        return rpcEndpoint;
    });
}
exports.buildWsRpcClient = buildWsRpcClient;
function _requestServersideEndpointForChannel(args) {
    return __awaiter(this, void 0, void 0, function* () {
        const { transport, dataForRpcChannel, timeoutMs } = args;
        const wsRpcHandshakeToken = dataForRpcChannel[constants_iso_1.Internal_WsRpcHandshakeTokenAttribName];
        if (!wsRpcHandshakeToken) {
            throw new Error('WsRpcHandshakeTokenRequired');
        }
        const wsClient = transport.getRawWebSocket();
        if (!wsClient) {
            throw new Error('WebsocketConnectionFailed');
        }
        let isResolved = false;
        let timer;
        const promise = new Promise((resolve, reject) => {
            let _markResolved;
            let listenForEstablishedRpcChannel = (rawMsg) => {
                _markResolved = () => {
                    if (!isResolved) {
                        isResolved = true;
                        listenForEstablishedRpcChannel && wsClient.removeListener('message', listenForEstablishedRpcChannel);
                        listenForEstablishedRpcChannel = null;
                    }
                };
                let data;
                try {
                    data = extract_and_parse_message_1.extractAndParseMessage(rawMsg);
                }
                catch (err) {
                    console.warn('Ignoring invalid websocket message', rawMsg);
                }
                if (data && typeof data === 'object' && data[HousekeepingMessageMarker] && data[constants_iso_1.Internal_WsRpcHandshakeTokenAttribName] === wsRpcHandshakeToken) {
                    clearTimeout(timer);
                    _markResolved && _markResolved();
                    if (data.rpcChannel) {
                        resolve(data);
                    }
                    else if (!data.ok) {
                        reject(data);
                    }
                }
            };
            timer = setTimeout(() => {
                if (!isResolved) {
                    _markResolved && _markResolved();
                    reject({
                        errorCode: 'WsRpcServerConnectionFailed',
                        details: {
                            reason: `Did not receive a response from WsRpcServer in ${timeoutMs} ms`,
                        }
                    });
                }
            }, timeoutMs);
            wsClient.addListener('message', listenForEstablishedRpcChannel);
        });
        wsClient.send(shared_utils_iso_1.safeStringify({
            [InboundWsRpcCommand.CreateRpcChannel]: dataForRpcChannel, // todo: shared location and use: InboundWsRpcCommand.CreateRpcChannel
        }));
        return promise;
    });
}
function _isRpcWsTransportForClient(obj) {
    return obj && ['sendMessage', 'stopTransport', 'getRawWebSocket'].every(m => typeof obj[m] === 'function');
}
// TODO: need place to share interfaces between ws-server and ws-client. Currently copy-pasted. :/
var InboundWsRpcCommand;
(function (InboundWsRpcCommand) {
    InboundWsRpcCommand["CreateRpcChannel"] = "CreateRpcChannel";
})(InboundWsRpcCommand || (InboundWsRpcCommand = {}));
//# sourceMappingURL=ws-rpc-client.js.map